import ReceiptIcon from "./ReceiptIcon";

export default function ReceiptHero({ serviceId, serviceDate, count }) {
  const date = serviceDate ? new Date(serviceDate).toLocaleDateString("fa-IR") : "—";
  return <section className="receipt-hero">
    <span className="receipt-hero__check"><ReceiptIcon name="check" /></span>
    <div><small>با موفقیت ثبت شد</small><h1>سرویس خودرو ثبت شد</h1><p>{count.toLocaleString("fa-IR")} مورد در سوابق خودرو ذخیره شد.</p></div>
    <dl><div><dt>شماره رسید</dt><dd>#{Number(serviceId).toLocaleString("fa-IR")}</dd></div><div><dt>تاریخ سرویس</dt><dd>{date}</dd></div></dl>
  </section>;
}
